export default __webpack_public_path__ + "static/media/06_zavlazovani-zahonu.3351ca22.jpg";